module.exports = __webpack_public_path__ + "media/images/hero-mobile-9a07f6b1af0e221a1abe867052ebef25.png";